import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import CLIENT from "@gql/queries/client/client";

const usePartyLabels = ({ clientId }) => {
  const { data } = useQuery(CLIENT, {
    variables: { where: { id: clientId } },
    skip: !clientId,
  });

  const partyLabels = useMemo(() => {
    const clientFirstName = data?.client?.profile?.firstName || "Client First Name";
    const exFirstName = data?.client?.exProfile?.firstName || "Ex First Name";

    const clientLastName = data?.client?.profile?.lastName || "Client Last Name";
    const exLastName = data?.client?.exProfile?.lastName || "Ex Last Name";

    const clientParentName = data?.client?.profile?.gender === "FEMALE" ? "Mother" : "Father";
    const exParentName = data?.client?.exProfile?.gender === "MALE" ? "Father" : "Mother";

    return [
      {
        clientLabel: clientFirstName,
        exLabel: exFirstName,
        party: "FIRSTNAME",
        indicator: "{firstName}",
      },
      {
        clientLabel: clientLastName,
        exLabel: exLastName,
        party: "LASTNAME",
        indicator: "{lastName}",
      },
      {
        clientLabel: "Client",
        exLabel: "Former Spouse",
        party: "DEFAULT",
      },
      {
        clientLabel: "Client",
        exLabel: "Spouse",
        party: "SPOUSE",
      },
      {
        clientLabel: "Client",
        exLabel: "Partner",
        party: "PARTNER",
      },
      {
        clientLabel: "Client",
        exLabel: "Opposing Party",
        party: "OPPOSING_PARTY",
      },
      {
        clientLabel: clientParentName,
        exLabel: exParentName,
        party: "PARENT",
      },
      {
        clientLabel: "Person 1",
        exLabel: "Person 2",
        party: "PERSON",
      },
    ];
  }, [data]);

  if (!data) {
    return [];
  }

  return partyLabels;
};

export default usePartyLabels;
